import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import companiesApi from "src/configs/apis/companies";
import ReassignHistoryDialogComponent from "./reassign-history.component";

export default function ReassignHistoryDialogContainer({
  selectedCompany,
  handleClose,
  isOpen,
}) {
  const dispatch = useDispatch();
  const [logs, setLogs] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isError, setIsError] = useState(false);
  const [total, setTotal] = useState(false);
  const [tableFilter, setTableFilter] = useState({
    page: 0,
    rowsPerPage: 25,
    order: "desc",
    orderBy: "created_at",
  });
  const rowsPerPageOption = [10, 25, 50];

  const handleDataLoad = () => {
    setIsFetching(true);
    setIsError(false);

    companiesApi
      .getReassignHistory({
        start: tableFilter.page * tableFilter.rowsPerPage,
        length: tableFilter.rowsPerPage,
        order: tableFilter.order,
        column: tableFilter.orderBy,
        company_uuid: selectedCompany.company.id,
      })
      .then((res) => {
        setLogs(res.data.data || []);
        setTotal(res.data.recordsFiltered || 0);
      })
      .catch((err) => {
        setIsError(true);
      })
      .finally(() => {
        setIsFetching(false);
      });
  };

  useEffect(() => {
    if (isOpen) {
      handleDataLoad();
    }
  }, [tableFilter, isOpen]);

  const handleChangePage = (newPage) => {
    const newData = {
      ...tableFilter,
      page: newPage,
    };
    setTableFilter(newData);
  };

  const handleChangeRowsPerPage = (value) => {
    const newData = {
      ...tableFilter,
      page: 0,
      rowsPerPage: value,
    };
    setTableFilter(newData);
  };

  // const changeOrder = (order) => {
  //   const newData = {
  //     ...tableFilter,
  //     order,
  //   };
  //   setTableFilter(newData);
  // };

  const handleReload = () => {
    const newData = {
      ...tableFilter,
      page: 0,
      rowsPerPage: 25,
    };
    setTableFilter(newData);
  };

  return (
    <ReassignHistoryDialogComponent
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      filter={tableFilter}
      logs={logs}
      isError={isError}
      isFetching={isFetching}
      total={total}
      handleClose={handleClose}
      isOpen={isOpen}
      rowsPerPageOption={rowsPerPageOption}
      handleReload={handleReload}
    />
  );
}
